import { includes } from 'lodash';
import PaymentCard from './paymentCard';

interface ValidateJS {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validators: Record<string, (value: any, options: any) => void>;
}

const addPaymentValidators = (validate: ValidateJS) => {
    validate.validators.truth = (value, options) => (value !== true ? options.message : null);

    validate.validators.number = (value, options) => (PaymentCard.validateCardNumber(value) ? null : options.message);

    validate.validators.numberType = (value, options) => {
        const card = PaymentCard.cardFromNumber(value);

        // card is recognized but not supported
        if (card && !includes(options.types, card.type)) {
            return options.message(card.name);
        }

        return null;
    };

    validate.validators.expiration = (value = '', options) => {
        const { month, year } = PaymentCard.cardExpiryValue(value);
        return PaymentCard.validateCardExpiry(month.toString(), year.toString()) ? null : options.message;
    };

    validate.validators.cvv = (value = '', options) =>
        PaymentCard.validateCardCVC(value, null) ? null : options.message;
};

export default addPaymentValidators;
